import React from "react";

import { BASE_URL } from "../config/config";
import useFetch from "../hooks/useFetch";

import "../styles/hot-offer.css";
import CarCard from "./CarCard";
import TrendingBrandCard from "./TrendingBrandCard";
import { useNavigate } from "react-router-dom";

const TrendingBrand = () => {
  const navigate = useNavigate();
  const {
    data: carData,
    isPending,
    error,
  } = useFetch(`${BASE_URL}api/Booking/get-trending-brands`);
  return (
    <>
      {isPending && <h6 className="text-center">Loading......</h6>}
      {error && <h6 className="text-center">{error}</h6>}

      {carData &&
        carData
          .slice(0, 6)
          .map((item, index) => (
            <TrendingBrandCard
              item={item}
              key={index}
              onClick={() => navigate(`/car-listing?param=${item.brandName}`)}
            />
          ))}
    </>
  );
};

export default TrendingBrand;
